import type { LegalBlock } from "../legal-document";

const content: LegalBlock[] = [
  {
    "type": "title",
    "text": "Chính sách quyền riêng tư của Vay3Phút"
  },
  {
    "type": "heading",
    "text": "1. Giới thiệu về Chính sách quyền riêng tư"
  },
  {
    "type": "paragraph",
    "text": "Vay3Phút hướng đến việc cung cấp dịch vụ vay kỹ thuật số thuận tiện cho người dùng tại Việt Nam, đồng thời luôn chú trọng đến việc bảo vệ thông tin cá nhân và quyền riêng tư của bạn. Chính sách quyền riêng tư này nhằm giải thích những thông tin mà Vay3Phút có thể thu thập khi bạn sử dụng ứng dụng Vay3Phút (“Ứng dụng”) và các dịch vụ liên quan, lý do thu thập, cách thông tin được sử dụng và lưu trữ, cũng như các biện pháp mà chúng tôi áp dụng để bảo vệ dữ liệu cá nhân của bạn."
  },
  {
    "type": "paragraph",
    "text": "Chúng tôi xử lý và bảo vệ thông tin người dùng phù hợp với các quy định pháp luật hiện hành của Việt Nam và các yêu cầu liên quan đến quyền riêng tư, an toàn dữ liệu của Google Play."
  },
  {
    "type": "paragraph",
    "text": "Khi cài đặt, truy cập hoặc sử dụng Ứng dụng Vay3Phút, bạn xác nhận rằng mình đã đọc và hiểu nội dung của Chính sách quyền riêng tư này. Đối với những thông tin cá nhân hoặc quyền truy cập thiết bị cần có sự cho phép của bạn, chúng tôi sẽ yêu cầu sự đồng ý phù hợp theo từng trường hợp."
  },
  {
    "type": "heading",
    "text": "2. Thông tin chúng tôi có thể thu thập"
  },
  {
    "type": "paragraph",
    "text": "Để hỗ trợ đăng ký tài khoản, cung cấp dịch vụ vay, bảo vệ tài khoản và hạn chế các rủi ro gian lận, Vay3Phút có thể thu thập và xử lý một số thông tin liên quan đến bạn khi có căn cứ và sự cho phép cần thiết. Các nhóm thông tin có thể bao gồm:"
  },
  {
    "type": "subheading",
    "text": "A. Thông tin do bạn cung cấp"
  },
  {
    "type": "paragraph",
    "text": "Trong quá trình tạo tài khoản, gửi yêu cầu vay hoặc sử dụng các dịch vụ liên quan, bạn có thể được yêu cầu cung cấp một số thông tin như:"
  },
  {
    "type": "list",
    "items": [
      "Họ tên, giới tính và ngày tháng năm sinh;",
      "Thông tin trên giấy tờ tùy thân, chẳng hạn như Căn cước công dân (CCCD) hoặc giấy tờ nhận dạng hợp lệ khác;",
      "Số điện thoại, địa chỉ email và địa chỉ cư trú;",
      "Thông tin về nghề nghiệp, thu nhập, trình độ học vấn và các thông tin liên quan;",
      "Họ tên, số điện thoại và mối quan hệ của người liên hệ khẩn cấp do bạn chủ động cung cấp;",
      "Thông tin tài khoản ngân hàng hoặc ví điện tử được sử dụng để nhận tiền vay hoặc thực hiện nghĩa vụ thanh toán."
    ]
  },
  {
    "type": "subheading",
    "text": "B. Thông tin liên quan đến thiết bị"
  },
  {
    "type": "paragraph",
    "text": "Để phát hiện hoạt động bất thường, bảo vệ tài khoản và thiết bị, đồng thời cải thiện khả năng vận hành của Ứng dụng, chúng tôi có thể thu thập một số thông tin kỹ thuật liên quan đến thiết bị, chẳng hạn như:"
  },
  {
    "type": "list",
    "items": [
      "Loại thiết bị, nhà sản xuất và phiên bản hệ điều hành;",
      "Dung lượng RAM và trạng thái bộ nhớ của thiết bị;",
      "Một số thông tin liên quan đến SIM và mạng di động như MCC, MNC và trạng thái chuyển vùng;",
      "Địa chỉ IP, loại kết nối mạng và trạng thái Wi-Fi;",
      "Các mã nhận dạng thiết bị không cố định như Android SSAID;",
      "Google Advertising ID nhằm phục vụ phân tích hoặc quảng cáo không được cá nhân hóa."
    ]
  },
  {
    "type": "subheading",
    "text": "C. Tin nhắn SMS liên quan đến hoạt động tài chính"
  },
  {
    "type": "paragraph",
    "text": "Khi bạn cấp quyền truy cập phù hợp, Vay3Phút có thể đọc các tin nhắn SMS có liên quan đến giao dịch tài chính, chẳng hạn như thông báo được gửi từ ngân hàng, tổ chức thanh toán hoặc ví điện tử."
  },
  {
    "type": "paragraph",
    "text": "Thông tin liên quan có thể được sử dụng để:"
  },
  {
    "type": "list",
    "items": [
      "Hỗ trợ xem xét và đánh giá tình hình tài chính của bạn;",
      "Đối chiếu và xác minh thông tin giao dịch;",
      "Nhận diện, phòng ngừa các hành vi gian lận hoặc hoạt động bất thường."
    ]
  },
  {
    "type": "paragraph",
    "text": "Chúng tôi không chủ động đọc, thu thập hoặc lưu trữ nội dung tin nhắn cá nhân không liên quan đến hoạt động tài chính."
  },
  {
    "type": "subheading",
    "text": "D. Thông tin người liên hệ khẩn cấp"
  },
  {
    "type": "paragraph",
    "text": "Nếu bạn chủ động cung cấp thông tin của người liên hệ khẩn cấp trong quá trình sử dụng dịch vụ, chúng tôi có thể sử dụng họ tên, số điện thoại và mối quan hệ mà bạn cung cấp để hỗ trợ xác minh thông tin và đánh giá rủi ro khi cần thiết."
  },
  {
    "type": "paragraph",
    "text": "Vay3Phút không tự động truy cập toàn bộ danh bạ trên thiết bị của bạn cho mục đích này."
  },
  {
    "type": "subheading",
    "text": "E. Thông tin về ứng dụng trên thiết bị"
  },
  {
    "type": "paragraph",
    "text": "Trong một số trường hợp liên quan đến an toàn hệ thống và quản lý rủi ro, chúng tôi có thể thu thập một số thông tin cơ bản về các ứng dụng được cài đặt trên thiết bị, chẳng hạn như tên ứng dụng hoặc tên gói ứng dụng."
  },
  {
    "type": "paragraph",
    "text": "Thông tin này chủ yếu được sử dụng để:"
  },
  {
    "type": "list",
    "items": [
      "Nhận biết các dấu hiệu bất thường hoặc nguy cơ gian lận;",
      "Kiểm tra và nâng cao mức độ an toàn của môi trường thiết bị."
    ]
  },
  {
    "type": "paragraph",
    "text": "Chúng tôi không truy cập nội dung hoặc dữ liệu bên trong các ứng dụng của bên thứ ba."
  },
  {
    "type": "subheading",
    "text": "F. Quyền truy cập camera"
  },
  {
    "type": "paragraph",
    "text": "Khi thực hiện xác minh danh tính hoặc gửi hồ sơ, Ứng dụng có thể yêu cầu quyền sử dụng camera để bạn chụp và tải lên:"
  },
  {
    "type": "list",
    "items": [
      "Hình ảnh giấy tờ tùy thân;",
      "Hình ảnh phục vụ việc xác minh danh tính;",
      "Các tài liệu hoặc giấy tờ khác cần thiết cho hồ sơ vay."
    ]
  },
  {
    "type": "paragraph",
    "text": "Những hình ảnh này chủ yếu được sử dụng cho việc xác minh danh tính và xem xét hồ sơ vay. Trừ khi bạn cho phép hoặc pháp luật có quy định khác, chúng tôi không sử dụng các hình ảnh này cho những mục đích không liên quan hoặc cung cấp cho bên thứ ba."
  },
  {
    "type": "subheading",
    "text": "G. Thông tin vị trí"
  },
  {
    "type": "paragraph",
    "text": "Chúng tôi có thể xác định vị trí gần đúng của bạn dựa trên địa chỉ IP hoặc một số thông tin liên quan đến kết nối mạng nhằm:"
  },
  {
    "type": "list",
    "items": [
      "Hỗ trợ xác minh tính hợp lệ của thông tin người dùng;",
      "Nhận diện và phòng ngừa các dấu hiệu gian lận;",
      "Cung cấp dịch vụ phù hợp hơn với khu vực của bạn."
    ]
  },
  {
    "type": "paragraph",
    "text": "Quyền truy cập thông tin vị trí chỉ được sử dụng khi Ứng dụng đang hoạt động và khi cần thiết cho các mục đích nêu trên."
  },
  {
    "type": "subheading",
    "text": "H. Nhật ký cuộc gọi"
  },
  {
    "type": "paragraph",
    "text": "Nhằm hỗ trợ quá trình đăng ký, đăng nhập và xác thực tài khoản, Ứng dụng có thể sử dụng một phần thông tin nhật ký cuộc gọi gần đây khi được bạn cấp quyền phù hợp."
  },
  {
    "type": "paragraph",
    "text": "Trong quá trình đăng ký hoặc đăng nhập, hệ thống có thể thực hiện cuộc gọi tự động đến số điện thoại mà bạn đã đăng ký để xác minh. Để kiểm tra quá trình xác minh có hoàn tất hay không, Ứng dụng có thể kiểm tra một số thông tin liên quan đến cuộc gọi này, chẳng hạn như số điện thoại, thời điểm gọi và trạng thái cuộc gọi."
  },
  {
    "type": "paragraph",
    "text": "Thông tin nhật ký cuộc gọi chỉ được sử dụng nhằm:"
  },
  {
    "type": "list",
    "items": [
      "Xác minh danh tính;",
      "Xác thực tài khoản;",
      "Hỗ trợ quá trình đăng nhập thuận tiện hơn."
    ]
  },
  {
    "type": "paragraph",
    "text": "Chúng tôi không sử dụng thông tin nhật ký cuộc gọi cho quảng cáo hoặc tiếp thị, không dùng thông tin này để đánh giá tín dụng và không bán hoặc chia sẻ cho bên thứ ba vì mục đích thương mại."
  },
  {
    "type": "heading",
    "text": "3. Mục đích sử dụng thông tin"
  },
  {
    "type": "paragraph",
    "text": "Vay3Phút sử dụng thông tin được thu thập trong phạm vi phù hợp với pháp luật và nhu cầu cung cấp dịch vụ, bao gồm:"
  },
  {
    "type": "list",
    "items": [
      "Xác minh danh tính và tăng cường bảo vệ tài khoản;",
      "Xem xét thông tin hồ sơ vay và khả năng thanh toán;",
      "Tiếp nhận, xử lý yêu cầu vay, giải ngân và các hoạt động liên quan đến thanh toán;",
      "Phát hiện, ngăn chặn gian lận, hành vi bất thường và các rủi ro có thể phát sinh;",
      "Hỗ trợ khách hàng và gửi các thông báo cần thiết liên quan đến dịch vụ;",
      "Thực hiện các nghĩa vụ về phòng, chống rửa tiền (AML) và các nghĩa vụ pháp lý khác;",
      "Phân tích, cải thiện hiệu suất, chức năng của Ứng dụng và trải nghiệm người dùng."
    ]
  },
  {
    "type": "heading",
    "text": "4. Chia sẻ thông tin"
  },
  {
    "type": "paragraph",
    "text": "Chúng tôi không bán, cho thuê, trao đổi hoặc thực hiện các hình thức mua bán trái phép đối với thông tin cá nhân của bạn và không sử dụng thông tin của bạn cho các mục đích thương mại chưa được phép."
  },
  {
    "type": "paragraph",
    "text": "Trong trường hợp cần thiết để cung cấp dịch vụ, bảo vệ hệ thống hoặc thực hiện nghĩa vụ pháp lý, chúng tôi có thể cung cấp một phần thông tin cần thiết cho các bên sau:"
  },
  {
    "type": "subheading",
    "text": "A. Nhà cung cấp dịch vụ"
  },
  {
    "type": "paragraph",
    "text": "Vay3Phút có thể sử dụng dịch vụ của các đối tác hỗ trợ về kỹ thuật hoặc vận hành, chẳng hạn như:"
  },
  {
    "type": "list",
    "items": [
      "Đơn vị cung cấp dịch vụ lưu trữ dữ liệu;",
      "Đơn vị hỗ trợ xác minh danh tính;",
      "Đơn vị xử lý thanh toán;",
      "Đơn vị cung cấp dịch vụ phân tích hệ thống và dữ liệu."
    ]
  },
  {
    "type": "paragraph",
    "text": "Các đối tác liên quan được yêu cầu áp dụng các biện pháp bảo mật và bảo vệ dữ liệu phù hợp, đồng thời chỉ được xử lý thông tin trong phạm vi cần thiết để cung cấp dịch vụ."
  },
  {
    "type": "subheading",
    "text": "B. Cơ quan nhà nước theo quy định pháp luật"
  },
  {
    "type": "paragraph",
    "text": "Khi cơ quan nhà nước có thẩm quyền, tòa án hoặc cơ quan quản lý hợp pháp tại Việt Nam có yêu cầu phù hợp với quy định pháp luật, chúng tôi có thể cung cấp thông tin liên quan theo đúng yêu cầu đó."
  },
  {
    "type": "subheading",
    "text": "C. Đơn vị xác minh tín dụng và đánh giá rủi ro hợp pháp"
  },
  {
    "type": "paragraph",
    "text": "Khi cần thiết cho hoạt động cung cấp dịch vụ và được pháp luật cho phép, một số thông tin cần thiết có thể được cung cấp cho các đơn vị xác minh tín dụng hoặc đánh giá rủi ro hợp pháp nhằm hỗ trợ đánh giá tín dụng và phòng ngừa gian lận."
  },
  {
    "type": "heading",
    "text": "5. Bảo mật dữ liệu"
  },
  {
    "type": "paragraph",
    "text": "Vay3Phút coi trọng việc bảo vệ an toàn thông tin cá nhân của bạn và áp dụng các biện pháp kỹ thuật, quản lý phù hợp nhằm hạn chế nguy cơ thông tin bị truy cập, sử dụng, thay đổi hoặc tiết lộ trái phép."
  },
  {
    "type": "paragraph",
    "text": "Các biện pháp bảo mật có thể bao gồm:"
  },
  {
    "type": "list",
    "items": [
      "Áp dụng công nghệ như SSL để bảo vệ dữ liệu;",
      "Sử dụng kết nối HTTPS an toàn khi truyền dữ liệu;",
      "Kiểm soát và phân quyền truy cập dữ liệu trong nội bộ;",
      "Thường xuyên kiểm tra và đánh giá mức độ an toàn của hệ thống."
    ]
  },
  {
    "type": "paragraph",
    "text": "Dữ liệu có thể được lưu trữ trên hệ thống máy chủ được bảo vệ, bao gồm:"
  },
  {
    "type": "paragraph",
    "text": "api.vay3phut.com"
  },
  {
    "type": "heading",
    "text": "6. Thời gian lưu trữ dữ liệu"
  },
  {
    "type": "paragraph",
    "text": "Chúng tôi chỉ lưu giữ thông tin cá nhân trong khoảng thời gian cần thiết để thực hiện các mục đích được nêu trong Chính sách này và đáp ứng các nghĩa vụ pháp lý có liên quan."
  },
  {
    "type": "paragraph",
    "text": "Thông tin có thể được lưu giữ nhằm:"
  },
  {
    "type": "list",
    "items": [
      "Duy trì và cung cấp dịch vụ vay cùng các dịch vụ liên quan;",
      "Thực hiện nghĩa vụ theo quy định pháp luật;",
      "Xử lý và giải quyết các tranh chấp có thể phát sinh;",
      "Phục vụ hoạt động kiểm toán, kiểm tra hoặc yêu cầu quản lý khi cần thiết."
    ]
  },
  {
    "type": "paragraph",
    "text": "Khi thông tin không còn cần thiết cho các mục đích nêu trên và pháp luật không yêu cầu tiếp tục lưu trữ, chúng tôi sẽ xóa, hủy hoặc ẩn danh dữ liệu theo quy định áp dụng."
  },
  {
    "type": "heading",
    "text": "7. Quyền của bạn đối với thông tin cá nhân"
  },
  {
    "type": "paragraph",
    "text": "Trong phạm vi pháp luật cho phép, bạn có thể thực hiện các quyền liên quan đến thông tin cá nhân của mình, bao gồm:"
  },
  {
    "type": "list",
    "items": [
      "Yêu cầu biết và xem các thông tin cá nhân mà chúng tôi đang lưu giữ;",
      "Đề nghị cập nhật hoặc chỉnh sửa thông tin không chính xác hoặc chưa đầy đủ;",
      "Rút lại sự cho phép đối với việc truy cập hoặc xử lý dữ liệu trong trường hợp phù hợp;",
      "Yêu cầu xóa thông tin cá nhân theo quy định pháp luật."
    ]
  },
  {
    "type": "paragraph",
    "text": "Nếu muốn thực hiện các quyền trên, bạn có thể liên hệ với bộ phận hỗ trợ của Vay3Phút. Chúng tôi sẽ xem xét và xử lý yêu cầu của bạn trong phạm vi pháp luật hiện hành cho phép."
  },
  {
    "type": "heading",
    "text": "8. Xóa tài khoản"
  },
  {
    "type": "paragraph",
    "text": "Nếu bạn không còn nhu cầu sử dụng Vay3Phút, bạn có thể gửi yêu cầu để đề nghị xóa tài khoản."
  },
  {
    "type": "paragraph",
    "text": "Trong trường hợp tài khoản vẫn còn khoản vay, nghĩa vụ thanh toán hoặc các nghĩa vụ liên quan chưa được hoàn tất, việc xóa tài khoản có thể chỉ được thực hiện sau khi các nghĩa vụ đó được giải quyết."
  },
  {
    "type": "paragraph",
    "text": "Sau khi tài khoản được xóa, một số thông tin vẫn có thể được chúng tôi lưu giữ nếu pháp luật yêu cầu hoặc cho phép, chẳng hạn để thực hiện nghĩa vụ pháp lý, giải quyết tranh chấp hoặc đáp ứng yêu cầu quản lý."
  },
  {
    "type": "heading",
    "text": "9. Chuyển dữ liệu ra nước ngoài"
  },
  {
    "type": "paragraph",
    "text": "Để duy trì hoạt động ổn định của hệ thống, nâng cao hiệu quả cung cấp dịch vụ hoặc sử dụng các dịch vụ kỹ thuật cần thiết, một phần thông tin của bạn có thể được xử lý hoặc lưu trữ trên máy chủ hoặc hệ thống thông tin đặt ngoài lãnh thổ Việt Nam."
  },
  {
    "type": "paragraph",
    "text": "Trong trường hợp dữ liệu được chuyển hoặc xử lý xuyên biên giới, chúng tôi sẽ áp dụng các biện pháp bảo vệ và an toàn dữ liệu phù hợp theo quy định pháp luật hiện hành nhằm hạn chế các rủi ro trong quá trình truyền và xử lý dữ liệu."
  },
  {
    "type": "heading",
    "text": "10. Cập nhật Chính sách quyền riêng tư"
  },
  {
    "type": "paragraph",
    "text": "Tiếng Việt："
  },
  {
    "type": "paragraph",
    "text": "Vay3Phút có thể điều chỉnh hoặc cập nhật Chính sách quyền riêng tư này khi có thay đổi về quy định pháp luật, tính năng dịch vụ hoặc phương thức xử lý dữ liệu."
  },
  {
    "type": "paragraph",
    "text": "Nếu có những thay đổi quan trọng, chúng tôi sẽ thông báo cho bạn thông qua Ứng dụng hoặc bằng phương thức liên hệ phù hợp."
  },
  {
    "type": "paragraph",
    "text": "Bạn nên thường xuyên xem lại Chính sách quyền riêng tư để nắm được cách chúng tôi thu thập, sử dụng, lưu trữ và bảo vệ thông tin của bạn."
  },
  {
    "type": "heading",
    "text": "11. Liên hệ với chúng tôi"
  },
  {
    "type": "paragraph",
    "text": "Nếu bạn có bất kỳ câu hỏi, ý kiến hoặc yêu cầu nào liên quan đến Chính sách quyền riêng tư, việc bảo vệ thông tin cá nhân hoặc cách Vay3Phút xử lý dữ liệu, vui lòng liên hệ với chúng tôi qua:"
  },
  {
    "type": "paragraph",
    "text": "Email: service@vay3phut.com"
  }
];

export default content;
